// eslint-disable-next-line @typescript-eslint/ban-types
export const toStringSerializer = (sourcePropertyValue?: object): string | undefined => {
   return sourcePropertyValue && sourcePropertyValue.toString();
};
